import React from 'react';
import ic_close from 'image/icon/ic_close_w.svg';
import ic_left from 'image/icon/ic_arrow_left_w.svg';
import ic_right from 'image/icon/ic_arrow_right_w.svg';
import {BtnIcon} from 'components/btns'

const PortfolioPreview = (props) => {
  return (
    <div className="wrap-imageView PortfolioPreview">
      <div className="wrap-images">
        
        <div className={`img-preview center` }>
          <img src={props.data[props.nowIndex].imageUrl} alt=""/>
          <div className="wrap-info center">
            <p className="category">#{props.data[props.nowIndex].category}</p>
            <p className="name">{props.data[props.nowIndex].name}</p>
            <p className="brand">{props.data[props.nowIndex].brand}</p>
          </div>
        </div>
        
      </div>
      <BtnIcon image = {ic_left} name="left" className={`btn-arrow-left btn-arrow ${props.nowIndex===0 ? `hide` : ``}`} onClick={props.handlePrevImageClick} />
      <BtnIcon image = {ic_right} name="right" className={`btn-arrow-right btn-arrow ${props.nowIndex===props.data.length-1 ? 'hide': ''}`} onClick={props.handleNextImageClick} />
      <BtnIcon image = {ic_close} name = "close" className="btn-close" onClick = {props.handleCloseClick}/>
      
      <div className="dim"></div>
    </div>
  );
}

export default PortfolioPreview;